import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { CHECKOUT_STEP_MAP, NEW_ADDRESS_STEP, NEW_BILLING_ADDRESS_STEP } from 'constants/checkoutFlow';

import css from 'styles/components/checkout/caap/address/addresslist/addressListHeader.scss';

const AddressListHeader = (componentParams, { testId }) => {
  const {
    addressType,
    isBilling,
    onCloseModalOverlayClick,
    purchaseId,
    showAsModal
  } = componentParams;

  if (!showAsModal) {
    return null;
  }

  return (
    <div className={css.addressTitleSection}>
      <div className={css.modalTitleContainer}>
        Choose a {addressType} address
        <button
          type="button"
          className={css.closeButton}
          data-test-id={testId('closeModal')}
          onClick={onCloseModalOverlayClick}
          onKeyPress={onCloseModalOverlayClick}
          role="link"
          tabIndex="0"
          title="Close Modal"></button>
      </div>
      <p>
        Please choose a {addressType} address from your address book below, or&nbsp;
        <Link to={isBilling ? `${CHECKOUT_STEP_MAP[NEW_BILLING_ADDRESS_STEP]}?pid=${purchaseId}` : `${CHECKOUT_STEP_MAP[NEW_ADDRESS_STEP]}?pid=${purchaseId}`}>
          enter a new {addressType} address.
        </Link>
      </p>
    </div>
  );
};

AddressListHeader.contextTypes = {
  testId: PropTypes.func
};

export default AddressListHeader;
